'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { get, useController, } from 'react-hook-form';
import { cn } from '../../utils';
import { genericForwardRef } from '../../utils/generic-forward-ref.js';
import { FormItem } from '../FormItem/FormItem';
import { Switch } from '../Switch/Switch';
const SwitchFieldRoot = React.forwardRef(({ label, description, error, onChange, value, className, ...props }, ref) => {
    return (_jsxs(FormItem, { ref: ref, error: error, className: cn('space-y-2', className), children: [_jsxs("div", { className: "flex flex-row items-center space-x-4", children: [_jsx(FormItem.Control, { children: _jsx(Switch, { onCheckedChange: (checked) => onChange?.(checked), checked: value, ...props }) }), _jsxs("div", { className: "space-y-0.5", children: [label && _jsx(FormItem.Label, { children: label }), description && (_jsx(FormItem.Description, { children: description }))] })] }), error && _jsx(FormItem.Error, { children: error })] }));
});
SwitchFieldRoot.displayName = 'SwitchField';
const SwitchFieldController = genericForwardRef(({ control, name, registerOptions, onChange: defaultOnChange, ...rest }, ref) => {
    const { field: { onChange, value }, formState: { errors }, } = useController({
        control,
        name,
    });
    const error = get(errors, name);
    return (_jsx(SwitchFieldRoot, { onCheckedChange: (checked) => {
            onChange(checked);
            if (defaultOnChange) {
                defaultOnChange(checked);
            }
        }, checked: value, error: error?.message, ref: ref, ...rest }));
}, 'SwitchFieldController');
export const SwitchField = Object.assign(SwitchFieldRoot, {
    Controller: SwitchFieldController,
});
//# sourceMappingURL=SwitchField.js.map